module.exports = __webpack_public_path__ + "img/faqs_layout4.16edcb64.png";